"use client";

import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";
import type { LeafletMapProps } from "./LeafletMap";

const LeafletMap = dynamic(
  () => import("./LeafletMap"),
  { ssr: false }
);

export default function LeafletMapWrapper(props: LeafletMapProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (shouldLoad) return;

    const element = wrapperRef.current;
    if (!element) return;

    if (!("IntersectionObserver" in window)) {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;

        setShouldLoad(true);
        observer.disconnect();
      },
      { rootMargin: "220px 0px" },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [shouldLoad]);

  if (!shouldLoad) {
    return (
      <div
        ref={wrapperRef}
        className={props.className}
        aria-label="در حال آماده‌سازی نقشه"
      />
    );
  }

  return <LeafletMap {...props} />;
}
